export type ThemeName = "classics" | "redesign" | "dark"

export interface ThemeMeta {
	name: ThemeName
	brightness: "dark" | "light"
	logoBrightness: "dark" | "light"
	background: string
	color: string
}

const THEMES: [ThemeMeta, ...ThemeMeta[]] = [
	{ name: "classics", brightness: "light", logoBrightness: "dark", background: "#1D4F91", color: "#FFFFFF" },
	{
		name: "redesign",
		brightness: "light",
		logoBrightness: "light",
		background: "#F1F2F5",
		color: "#000714",
	},
	{
		name: "dark",
		brightness: "dark",
		logoBrightness: "light",
		background: "#12141a",
		color: "#e6e8ec",
	},
] as const

export default THEMES
